var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 84,
    viewBox: "0 0 81 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0465,
    cy: 58.1827,
    rx: 25.2496,
    ry: 25.0191,
    fill: "#DBF3F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.957 48.8266V52.6668C57.957 58.1206 53.5358 62.5418 48.082 62.5418H18.457C13.0032 62.5418 8.58203 58.1206 8.58203 52.6668V26.3335C8.58203 20.8797 13.0032 16.4585 18.457 16.4585H48.082C53.5358 16.4585 57.957 20.8797 57.957 26.3335V30.1738L66.317 23.2072C69.5329 20.5273 74.4154 22.8141 74.4154 27.0003V52.0001C74.4154 56.1863 69.5329 58.4731 66.3169 55.7932L57.957 48.8266ZM18.457 19.7502H48.082C51.7179 19.7502 54.6654 22.6976 54.6654 26.3335V52.6668C54.6654 56.3027 51.7179 59.2502 48.082 59.2502H18.457C14.8212 59.2502 11.8737 56.3027 11.8737 52.6668V26.3335C11.8737 22.6976 14.8212 19.7502 18.457 19.7502ZM57.957 44.5418L68.4242 53.2645C69.4962 54.1578 71.1237 53.3955 71.1237 52.0001V27.0003C71.1237 25.6049 69.4962 24.8426 68.4242 25.7359L57.957 34.4586V44.5418Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.22b10c77f87cc0d8544737dc4cc10329.svg";
export { ForwardRef as ReactComponent };